import type { NavigationCapability } from "../types/navigation";

export type LibraryTile = {
  readonly id: string;
  readonly title: string;
  readonly description: string;
  readonly href: string;
  readonly requiredCapability: NavigationCapability;
};

export const libraryTiles: LibraryTile[] = [
  {
    id: "contracts",
    title: "Contracts",
    description: "Access and manage approved contract templates.",
    href: "/contracts-selection",
    requiredCapability: "contracts",
  },
  {
    id: "rfps",
    title: "RFPs",
    description: "Browse standardized RFP templates for proposals.",
    href: "/rfps",
    requiredCapability: "rfp",
  },
  {
    id: "rules",
    title: "Game Rule",
    description: "Manage KB clause sections and version history for game rules.",
    href: "/rules-selection",
    requiredCapability: "prize_rules",
  },
];
